module.exports = __webpack_public_path__ + "img/support-of-gobierno-de-españa.12ca5c72.jpg";